import { useNavigate } from 'react-router-dom';
import { VStack, Text, Button, Link, Heading, Box } from '@chakra-ui/react';
import errorAnimation from '../../../assets/auth/errorAnimation.json';
import Lottie from 'lottie-react';
export const InvalidInvitation = () => {
  const navigate = useNavigate();

  return (
    <VStack h="full" justify="center"  maxW="360px" mx="auto" textAlign="center">
      <Box justifyContent='center'  maxW='360px' mb="-4.5rem" zIndex="-1" mx='auto'  >
          {/* NOTE:Check do we want to move to login page after animation? */}
          <Lottie
            animationData={errorAnimation}
            onLoopComplete={() => {
              // navigate('/')
            }}
            loop={false}
          />
        </Box>
      <Heading as="h3" color="custom_blue.1"  fontSize="3xl">
        Invalid Invitation
      </Heading>
      <Text color="custom_gray.1" fontSize="md" mb="6">
        This invite may be expired or you might have used this link before.
      </Text>
      <Box textAlign="start" w="360px">

      <Button
        bg="custom_orange.2"
        _hover={{ bg: 'custom_orange.2' }}
        color="white"
        fontWeight="semibold"
        fontSize="sm"
        w="full"
        mb="2"
        onClick={() => navigate('/')}
        >
        Got it
      </Button>
      <Link
        color="custom_blue.1"
        fontSize="xs"
        textDecor="underline"
      >
        Why is my invite invalid?
      </Link>
        </Box>
    </VStack>
  );
};
